module.exports = __webpack_public_path__ + "static/media/img-about-cat@2x.f99bd837.png";